import { TFunction } from "i18next";
import { matchPath, useLocation } from "react-router-dom";
import { useTitle } from "react-use";

export interface RouteDef {
  path: string;
  titleKey: string;
}

/**
 * @param ROUTES - all of the routes for matching, each route should contain a `titleKey` to be used in translation
 * @param t - translation function
 */
export function useRouteNameAsDocumentTitle(ROUTES: Record<string, RouteDef>, t: TFunction<string>): void {
  const location = useLocation();

  const matchedRoute = Object.values(ROUTES).find(({ path }) => {
    const matchedPath = matchPath({ path }, location.pathname);
    return Boolean(matchedPath);
  });

  const documentTitleToSet = matchedRoute?.titleKey
    ? `${t(`pageTitles.${matchedRoute.titleKey}`)} - PayPing`
    : "PayPing";

  useTitle(documentTitleToSet);
}
